export const iconFontAwesomeSecurityHandsHoldingCircle = (
	<i className="fa-solid fa-hands-holding-circle"></i>
);
